/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_TR_TR: Record<string, string> = {
    ariaAnnounceChart: 'grafik, ${seriesCount}[number] seri',
    ariaAnnounceFlowProportionLink: 'bağlantı ${index} / ${count}, ${from} - ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'düğüm ${index} / ${count}, ${description}',
    ariaAnnounceGaugeChart: 'gösterge grafik, ${caption}',
    ariaAnnounceHierarchyChart: 'hiyerarşi grafiği, ${caption}',
    ariaAnnounceHierarchyDatum: 'seviye ${level}[number], ${count}[number] çocuk, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Görünürlüğü değiştirmek için Boşluk veya Enter tuşuna basın',
    ariaLabelAddHorizontalLine: 'Yatay Çizgi Ekle',
    ariaLabelAnnotationOptionsToolbar: 'Ek Açıklama Seçenekleri',
    ariaLabelAnnotationSettingsDialog: 'Ek Açıklama Ayarları',
    ariaLabelColorPicker: 'Renk seçici',
    ariaLabelFinancialCharts: 'Finansal Grafikler',
    ariaLabelLegend: 'Efsane',
    ariaLabelLegendItem: '${label}, Lejant öğesi ${index}[number] of ${count}[number]',
    ariaLabelLegendItemUnknown: 'Bilinmeyen efsane öğesi',
    ariaLabelLegendPageNext: 'Sonraki Efsane Sayfası',
    ariaLabelLegendPagePrevious: 'Önceki Efsane Sayfası',
    ariaLabelLegendPagination: 'Efsane Sayfalama',
    ariaLabelNavigator: 'Gezgin',
    ariaLabelNavigatorMaximum: 'Maksimum',
    ariaLabelNavigatorMinimum: 'Minimum',
    ariaLabelNavigatorRange: 'Aralık',
    ariaLabelRangesToolbar: 'Aralıklar',
    ariaLabelSettingsTabBar: 'Ayarlar',
    ariaLabelZoomToolbar: 'Yakınlaştır',
    ariaValuePanRange: '${min}[percent0to2dp] ile ${max}[percent0to2dp] arası',
    contextMenuDownload: 'İndir',
    contextMenuPanToCursor: 'Buraya kaydır',
    contextMenuToggleOtherSeries: 'Diğer Serileri Değiştir',
    contextMenuToggleSeriesVisibility: 'Görünürlüğü Değiştir',
    contextMenuZoomToCursor: 'Buraya yakınlaştır',
    dialogHeaderChannel: 'Kanal',
    dialogHeaderDatePriceRange: 'Tarih ve Fiyat',
    dialogHeaderDateRange: 'Tarih Aralığı',
    dialogHeaderFibonacciRange: 'Fib Geri Çekilme',
    dialogHeaderLine: 'Çizgi',
    dialogHeaderPriceRange: 'Fiyat Aralığı',
    dialogHeaderText: 'Metin',
    dialogInputAlign: 'Hizala',
    dialogInputColorPicker: 'Renk',
    dialogInputColorPickerAltText: 'Metin Rengi',
    dialogInputExtendAbove: 'Üstüne genişlet',
    dialogInputExtendBelow: 'Aşağıya genişlet',
    dialogInputExtendChannelEnd: 'Kanal sonunu uzat',
    dialogInputExtendChannelStart: 'Kanal başlangıcını uzat',
    dialogInputExtendLeft: 'Sola uzat',
    dialogInputExtendLineEnd: 'Çizgi ucunu uzat',
    dialogInputExtendLineStart: 'Çizgi başlangıcını uzat',
    dialogInputExtendRight: 'Sağa genişlet',
    dialogInputFibonacciBands: 'Bantlar',
    dialogInputFibonacciBandsAltText: 'Fibonacci Bantları',
    dialogInputFillColorPicker: 'Doldur',
    dialogInputFillColorPickerAltText: 'Doldurma Rengi',
    dialogInputFontSize: 'Yazı tipi boyutu',
    dialogInputFontSizeAltText: 'Yazı Boyutu',
    dialogInputLineStyle: 'Tire',
    dialogInputPosition: 'Konum',
    dialogInputReverse: 'Ters Çevir',
    dialogInputShowFill: 'Dolguyu Göster',
    dialogInputStrokeWidth: 'Çizgi Kalınlığı',
    dialogInputStrokeWidthAltText: 'Çizgi Ağırlığı',
    iconAltTextAlignCenter: 'Ortala',
    iconAltTextAlignLeft: 'Sola',
    iconAltTextAlignRight: 'Sağa',
    iconAltTextClose: 'Kapat',
    iconAltTextLineStyleDashed: 'Uzun tireli',
    iconAltTextLineStyleDotted: 'Kısa çizgili',
    iconAltTextLineStyleSolid: 'Düz',
    iconAltTextPositionBottom: 'Alt',
    iconAltTextPositionCenter: 'Merkez',
    iconAltTextPositionTop: 'Üst',
    inputTextareaPlaceholder: 'Metin Ekle',
    measurerDateRangeBars: '${value}[number] çubuk',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Hacim ${value}',
    overlayLoadingData: 'Veriler yükleniyor...',
    overlayNoData: 'Gösterilecek veri yok',
    overlayNoVisibleSeries: 'Görünen seri yok',
    overlayUnsupportedBrowser: 'Uyumsuz tarayıcı sürümü. Lütfen tarayıcınızı yükseltin.',
    seriesHistogramTooltipCount: '${yName} (sayım)',
    seriesHistogramTooltipFrequency: 'Frekans',
    seriesHistogramTooltipMean: '${yName} (ortalama)',
    seriesHistogramTooltipSum: '${yName} (toplam)',
    toolbarAnnotationsArrow: 'Ok',
    toolbarAnnotationsArrowDown: 'Aşağı Ok',
    toolbarAnnotationsArrowUp: 'Yukarı Ok',
    toolbarAnnotationsCallout: 'Balon',
    toolbarAnnotationsClearAll: 'Hepsini Temizle',
    toolbarAnnotationsComment: 'Yorum',
    toolbarAnnotationsDatePriceRange: 'Tarih ve Fiyat',
    toolbarAnnotationsDateRange: 'Tarih Aralığı',
    toolbarAnnotationsDelete: 'Sil',
    toolbarAnnotationsDisjointChannel: 'Ayrık Kanal',
    toolbarAnnotationsDragHandle: 'Araç Çubuğunu Sürükle',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Fib Düzeltme',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Fib Trend Tabanlı',
    toolbarAnnotationsFillColor: 'Doldurma Rengi',
    toolbarAnnotationsHorizontalLine: 'Yatay Çizgi',
    toolbarAnnotationsLineAnnotations: 'Trend Çizgileri',
    toolbarAnnotationsLineColor: 'Çizgi Rengi',
    toolbarAnnotationsLineStrokeWidth: 'Çizgi Kalınlığı',
    toolbarAnnotationsLineStyle: 'Çizgi Stili',
    toolbarAnnotationsLock: 'Kilitle',
    toolbarAnnotationsMeasurerAnnotations: 'Ölçümcüler',
    toolbarAnnotationsNote: 'Not',
    toolbarAnnotationsParallelChannel: 'Paralel Kanal',
    toolbarAnnotationsPriceRange: 'Fiyat Aralığı',
    toolbarAnnotationsQuickDatePriceRange: 'Ölçü',
    toolbarAnnotationsSettings: 'Ayarlar',
    toolbarAnnotationsShapeAnnotations: 'Oklar',
    toolbarAnnotationsText: 'Metin',
    toolbarAnnotationsTextAnnotations: 'Metin Açıklamaları',
    toolbarAnnotationsTextColor: 'Metin Rengi',
    toolbarAnnotationsTextSize: 'Yazı Boyutu',
    toolbarAnnotationsTrendLine: 'Trend Çizgisi',
    toolbarAnnotationsUnlock: 'Kilidi Aç',
    toolbarAnnotationsVerticalLine: 'Dikey Çizgi',
    toolbarRange1Month: '1A',
    toolbarRange1MonthAria: '1 ay',
    toolbarRange1Year: '1Y',
    toolbarRange1YearAria: '1 yıl',
    toolbarRange3Months: '3A',
    toolbarRange3MonthsAria: '3 ay',
    toolbarRange6Months: '6A',
    toolbarRange6MonthsAria: '6 ay',
    toolbarRangeAll: 'Tümü',
    toolbarRangeAllAria: 'Tümü',
    toolbarRangeYearToDate: "YTD'ye Kadar",
    toolbarRangeYearToDateAria: 'Yıl başından bu yana',
    toolbarSeriesTypeCandles: 'Mumlar',
    toolbarSeriesTypeDropdown: 'Grafik Türü',
    toolbarSeriesTypeHighLow: 'Yüksek Düşük',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Boş Mumlar',
    toolbarSeriesTypeLine: 'Çizgi',
    toolbarSeriesTypeLineWithMarkers: 'İşaretlerle Çizgi',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Basamak Çizgisi',
    toolbarZoomPanEnd: 'En sona kaydır',
    toolbarZoomPanLeft: 'Sola kaydır',
    toolbarZoomPanRight: 'Sağa kaydır',
    toolbarZoomPanStart: 'Başlangıca kaydır',
    toolbarZoomReset: 'Yakınlaştırmayı sıfırla',
    toolbarZoomZoomIn: 'Yakınlaştır',
    toolbarZoomZoomOut: 'Uzaklaştır',
    tooltipPaginationStatus: '${index}[number] / ${count}[number]',
};
